import React from 'react';
import  ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './analytics';
import { BrowserRouter } from 'react-router-dom'
//only applicable if react 18

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <App/>
    </BrowserRouter>
);
reportWebVitals();

//only applicable if not react 18
/*ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
    <App />
      </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);*/

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
